export class Area {
  public Id: number;
  public Descricao: string;
  public Ativo: boolean;

  constructor() {
    this.Id = 0;
    this.Descricao = "";
    this.Ativo = true;
  }
}
